import { type ReactNode, useMemo } from "react";
import { ConvexReactClient, ConvexProviderWithAuth } from "convex/react";

import { useAuthBridge } from "@/core/auth/useAuthBridge";

const CONVEX_URL = import.meta.env.VITE_CONVEX_URL;

if (!CONVEX_URL) {
  throw new Error(
    "VITE_CONVEX_URL is not set — copy .env.example to .env.local and configure it.",
  );
}

// Doit être instancié UNE FOIS au boot (hors composant), pas à chaque render.
// `logger: false` désactive les console.log info-level (ex: "WebSocket
// reconnected at t=..."). Les erreurs réelles passent quand même via le
// chemin natif promise-rejection / try-catch du SDK.
const convexClient = new ConvexReactClient(CONVEX_URL, { logger: false });

export function ConvexAuthProvider({ children }: { children: ReactNode }) {
  const useAuth = useMemo(() => useAuthBridge, []);
  return (
    <ConvexProviderWithAuth client={convexClient} useAuth={useAuth}>
      {children}
    </ConvexProviderWithAuth>
  );
}
